module.exports = __webpack_public_path__ + "static/homepage-hero-bg-ab535005b75978f76fc8fa324f785e00.jpg";